var pushdownHeight = 415;
var expandHeight = 300;

window.addEventListener("message", function (event) {
    
    var adPos = "";
    var origHeight = 90;
    var dataVal = event.data.toString();

    if (dataVal.indexOf("|") != -1) {
        var tempString = dataVal.split("|");
        adPos = tempString[0];
        origHeight = tempString[1];
    } else {
        adPos = event.data;
    }

    if (adPos == "Top1") {

        $(function () {
         
            $("#div-gpt-ad-" + adPos).animate({
                height: pushdownHeight + "px"
            }, { duration: 1000, queue: false });

            $("#div-gpt-ad-" + adPos + " iframe").animate({
                height: pushdownHeight + "px"
            }, { duration: 1000, queue: false });

            if (pushdownHeight == 415)
                pushdownHeight = origHeight;
            else
                pushdownHeight = 415;

        });

    }

    if (event.data == "Top") {

        var adPos = event.data;

        $(function () {
		
            $("#div-gpt-ad-" + adPos).parent().css({
                //position: "relative",
                height: "90px",
                zIndex: "100000"
            });

            $("#div-gpt-ad-" + adPos + " iframe").animate({
                height: expandHeight + "px" //,
            }, { duration: 1000, queue: false });

            if (expandHeight == 300)
                expandHeight = 90;
            else
                expandHeight = 300;

        });

    }

});